// src/app/services/evapPackApi.ts
import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './apiConfig';
import { IEvapPack, IEvapPackParams, UpdatePayload } from '../models';

export const evapPackApi = createApi({
  reducerPath: 'evapPackApi',
  baseQuery,
  endpoints: (builder) => ({
    getEvapPackParams: builder.query<{ evap_pack: IEvapPackParams }, void>({
      query: () => `/api/v1.0/cms/1/v1.0.0/ahu/evap_pack/params/`,
      keepUnusedDataFor: Infinity, // Keep the cached data until the page reloads
    }),
    getEvapPack: builder.query<IEvapPack, number>({
      query: (id) => `/api/v1.0/ahu/evap_packs/${id}`,
      transformResponse: (data: IEvapPack) => {
        data.fillParams = data ? JSON.parse(data.fill_params) : {};
        data.mediaParams = data ? JSON.parse(data.media_params) : {};
        data.pumpParams = data ? JSON.parse(data.pump_params) : {};
        data.overflowParams = data ? JSON.parse(data.overflow_params) : {};
        data.drainParams = data ? JSON.parse(data.drain_params) : {};
        return data;
      },
    }),
    getAllEvapPackParamsCount: builder.query<{ count: number }, string>({
      query: (type) =>
        `/api/v1.0/cms/1/v1.0.0/ahu/evap_pack/${type}/all/count/`,
      keepUnusedDataFor: Infinity, // Keep the cached data until the page reloads
    }),
    getEvapPackParamsCount: builder.query<
      { count: number },
      { queryString: string; type: string }
    >({
      query: ({ queryString, type }) =>
        `/api/v1.0/cms/1/v1.0.0/ahu/evap_pack/${type}/all/count/?${queryString}`,
      extraOptions: {
        cacheData: true,
      },
    }),
    //
    updateEvapPack: builder.mutation<IEvapPack, UpdatePayload<IEvapPack>>({
      query: ({ id, body, signal }) => ({
        url: `/api/v1.0/ahu/evap_packs/${id}`,
        method: 'PATCH',
        body,
        signal,
      }),
      transformResponse: (data: IEvapPack) => {
        data.fillParams = data ? JSON.parse(data.fill_params) : {};
        data.mediaParams = data ? JSON.parse(data.media_params) : {};
        data.pumpParams = data ? JSON.parse(data.pump_params) : {};
        data.overflowParams = data ? JSON.parse(data.overflow_params) : {};
        data.drainParams = data ? JSON.parse(data.drain_params) : {};
        return data;
      },
    }),
  }),
});

export const {
  useLazyGetEvapPackQuery,
  useGetEvapPackParamsQuery,
  useLazyGetEvapPackParamsCountQuery,
  useGetAllEvapPackParamsCountQuery,
  useUpdateEvapPackMutation,
} = evapPackApi;
